import { render } from "./DepotAttendantManagement.html?vue&type=template&id=28f234d4&scoped=true"
import script from "./DepotAttendantManagement.js?vue&type=script&lang=js"
export * from "./DepotAttendantManagement.js?vue&type=script&lang=js"

import "./DepotAttendantManagement.css?vue&type=style&index=0&id=28f234d4&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f234d4"]])

export default __exports__